import React, { useState, useEffect } from "react";
import { useTheme } from '@repo/shared';
import { useParams} from "react-router-dom";
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import AttendanceDataService from "../../services/class/AttendanceService";
import ClassDataService from "../../services/class/ClassService";
import LessonDataService from "../../services/class/LessonService";
import StudentDataService from "../../services/student/StudentService";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css


import "react-datepicker/dist/react-datepicker.css";
import AttendanceService from "../../services/class/AttendanceService";
import PlanDataService from "../../services/class/PlanService";

import 'react-tabs/style/react-tabs.css';

const Lesson = props => {
  const { id } = useParams();
  const initialAttendanceState = AttendanceDataService.initialiseNewAttendance();
  const [currentAttendances, setCurrentAttendances] = useState(initialAttendanceState);
  const [students, setStudents] = useState([]);
  const [currentClass, setCurrentClass] = useState({});
  const [lesson, setLesson] = useState({});
  const [attendanceGrid, setAttendanceGrid] = useState([]);
  const [dateHeader, setDateHeader] = useState([]);
  const [materialThemeArray, setMaterialThemeArray] = useState([]);
  const [loading, setLoading] = useState(true);

  const { appTheme } = useTheme();

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const fetchData = async (lessonId) => {
    try {
      const incomingLesson = await LessonDataService.getLesson(lessonId, 'class');
      setLesson(incomingLesson);

      console.log('about to call class.get');
      const clazz = await ClassDataService.get(incomingLesson.classId);
      setCurrentClass(clazz);

      clazz.dates
        .sort((a,b) => moment(a).diff(moment(b)))
        .forEach((d, index) => {
          if (d.getTime() === new Date(incomingLesson.classDate).getTime()) {
            incomingLesson.number = index+1;
          }
        });
      

      const incomingDateHeader = { title: moment(incomingLesson.classDate).format('DD MMM'), date: new Date(incomingLesson.classDate), editable: true, editing: false}
      setDateHeader(incomingDateHeader);

      const attendances = await AttendanceService.getForClass(clazz.id, incomingLesson.classDate);
      console.log(attendances);
      setCurrentAttendances(attendances);

      const studentsForClass = await StudentDataService.getAllForClass(clazz.id);
      const attendanceGrid = generateAttendanceGrid({attendances, dates: clazz.dates, studentsForClass});

      await refreshMaterials(clazz.id, incomingLesson.classDate)

      setAttendanceGrid(attendanceGrid);
      setStudents(studentsForClass);
    } catch (error) {
      console.error('Error fetching lesson data:', error);
      
    } finally {
      setLoading(false);
    }
  };

  const refreshMaterials = async (classId, lessonDate) => {
    const incomingMaterialsAsClassThemesMap = await PlanDataService.getMaterialsAsClassThemesMap(classId);
    const linkedClass = await ClassDataService.getLinkedClass(classId);

    //const incomingMaterialsAsClassThemesMapForLinkedClass = await PlanDataService.getMaterialsAsClassThemesMap('37e8a608-cb3f-4617-8931-8818a6dd6dfc');
    const incomingMaterialThemeArray = [];
    Object.keys(incomingMaterialsAsClassThemesMap).forEach(themeName => {
      const materialsForTheme = { 
        theme: themeName,
        materials: incomingMaterialsAsClassThemesMap[themeName].materials,
        classDate: incomingMaterialsAsClassThemesMap[themeName].classDate,
        priority: incomingMaterialsAsClassThemesMap[themeName].priority,
        currentClass: incomingMaterialsAsClassThemesMap[themeName].lessons?.find(l => l.classId === classId),
        linkedClass: linkedClass && incomingMaterialsAsClassThemesMap[themeName].lessons?.find(l => l.classId === linkedClass.id),
        currentLesson: incomingMaterialsAsClassThemesMap[themeName].lessons?.find(l => l.classId === classId && moment(l.classDate).isSame(moment(lessonDate))),
        ideas: incomingMaterialsAsClassThemesMap[themeName].ideas,
      };
      incomingMaterialThemeArray.push(materialsForTheme);

    });
    
    incomingMaterialThemeArray.sort((a,b) => {
      //Sort order: today, !used, priority

      if (a.currentLesson) return -1;
      if (b.currentLesson) return 1;

      if (a.currentClass || a.linkedClass) return 1;
      if (b.currentClass || b.linkedClass) return -1;

      

      return a.priority - b.priority;
    })
    setMaterialThemeArray(incomingMaterialThemeArray);
  }

  const generateAttendanceGrid = ({attendances, dates, studentsForClass}) => {
    //might not need this

    //columns headers = dates
    //row headers = students
    //cells = attendences[date][student] || empty
    const grid = {};
    studentsForClass.forEach(student => {
      const studentRow = {};
      grid[student.id] = studentRow;
      dates.forEach(date => {
        studentRow[date.getTime()] = {};

        //Here we need to lookup in attendances to see if we have an entry
        const found = attendances.find(attendance => attendance.studentId === student.id && attendance.classDate.getTime() === date.getTime());
        studentRow[date.getTime()].attendance = found ? found.attendance : '';
      });
    });

    return grid;
  };

  const saveLesson = async () => {
    const savedLesson = await LessonDataService.saveLesson(lesson.id, lesson);
    alert('Lesson notes saved');
  }

  const toggleAttendance = (cell) => {
    if (cell.attendance === 'Y') {
      cell.attendance = 'N';
    } else if (cell.attendance === 'N') {
      cell.attendance = 'E';
    } else {
      cell.attendance = 'Y'
    }
    setAttendanceGrid({...attendanceGrid});
  }

  const markThemeUsed = async (theme, markForAllClasses, markForAllClassesAtThisSchool) => {
    await LessonDataService.markThemeUsed(theme, lesson, markForAllClasses, markForAllClassesAtThisSchool);
    await refreshMaterials(currentClass.id, lesson.classDate);
  }

  const renderStudentAttendance = student => {
    const renderAttendanceField = () => {
      const attendanceDate = dateHeader.date;
      const studentRow = attendanceGrid[student.id];
      const cell = studentRow[attendanceDate.getTime()];

      const styleClass = cell?.attendance === 'Y' ? 'attendanceCheckBoxY' : cell?.attendance === 'E' ? 'attendanceCheckBoxE' : 'attendanceCheckBoxN';
      if (dateHeader?.editing) {
        return <td className={styleClass} onClick={() => toggleAttendance(cell)}>{cell?.attendance ? cell?.attendance : ''}</td>
      } else {
        return <td className={'attendanceCheckBox'}>{cell?.attendance ? cell?.attendance : ''}</td>
      }
    }

    return (
      <tr>
        <td className="attendanceNameColumn">
          <div>
            <div>
              <span className='majorText'>{student.firstName} {student.lastName}</span>
            </div>
            <div>
              <span className='minorText'>{student.year} {student.className}</span>
            </div>
            <div>
              <span className='minorText'>{student.notes}</span>
            </div>
          </div>
        </td>
        {renderAttendanceField()}
      </tr>
    )
  };

  const toggleExpandTheme = (themeObject) => {
    if (themeObject.expand) {
      themeObject.expand = false;
    } else {
      themeObject.expand = true;
    }
    setMaterialThemeArray([...materialThemeArray]);
  }

  const toggleEditRegister = (dateHeader) => {

    if (dateHeader.editing) {
      //currently editing, this will save
      confirmAlert({
        title: 'Attendance Complete',
        message: `Have you completed the register for ${dateHeader.title}?`,
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              //save attendence for this date

              const attendances = { classDate: dateHeader.date, studentRow: [] };
              
              students.forEach(student => {
                const attendanceGridStudentRow = attendanceGrid[student.id];
                attendances.studentRow.push({ studentClassId: student.studentClassId, attendance: attendanceGridStudentRow[dateHeader.date.getTime()].attendance ? attendanceGridStudentRow[dateHeader.date.getTime()].attendance : ''});
              });
              console.log('Persisting attendance for date', dateHeader.date, attendances);
              AttendanceDataService.update({ classId: currentClass.id, attendances});
              //then turn off editing
              dateHeader.editing = false;
              setDateHeader({...dateHeader});
            }
          },
          {
            label: 'No',
            onClick: () => {}
          },
          {
            label: 'Discard',
            onClick: () => fetchData(id)
          }
        ]
      });

      
    } else {
      dateHeader.editing = true;
      setDateHeader({...dateHeader});
    }
  }

  const deriveColorAndTag = (themeObject) => {
    const colorAndTag = { color: 'lightgray', tag:'' }
    if (!themeObject.currentClass && !themeObject.linkedClass) return colorAndTag;

    if (themeObject.currentLesson) {
      colorAndTag.tag = 'Used for this lesson'
      colorAndTag.color = 'lightgreen'
    } else if (themeObject.linkedClass) {
      colorAndTag.tag = ` Used last term on ${moment(themeObject.classDate).format('DD MMM')}`
      colorAndTag.color = '#ffa3be88';
    } else {
      colorAndTag.tag = ` Used on ${moment(themeObject.classDate).format('DD MMM')}`
      colorAndTag.color = 'var(--primary-color-semitransparent)';
      
    }

    return colorAndTag;
  }

  const renderThemeInfoButton = (themeObject) => {
    return (
      <button
        disabled={!themeObject.ideas}
        className="btn btn-outline-secondary"
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          alert(themeObject.ideas);
        }}
      >
        <span>
          <div style={{fontSize: 22}}>
            <i className="fas fa-info-circle action"></i>
          </div>
          <div style={{fontSize: 10}}>
            Theme Ideas
          </div>
        </span>
      </button>
    )
  }

  const renderMaterials = (byWeek) => {
    if (materialThemeArray) {
      const materialRows = materialThemeArray.map((themeObject) => {
        const materialForThemeRows = themeObject.expand ? themeObject.materials.map(material => {
          return (
            <tr>
              <td/>
              <td>
                <a href={`${material.url}`}>{material.name}</a>
              </td>
              <td>{material.level}</td>
            </tr>
          )
        }) : [];

        const colorAndTag = deriveColorAndTag(themeObject);

        const themeHeaderRow = (
          <tr style={{backgroundColor: colorAndTag.color, padding: 30}} onClick={() => toggleExpandTheme(themeObject)}>
              <td style={{maxWidth: 10}}>{ themeObject.expand ? <FontAwesomeIcon icon={faCaretUp}/> : <FontAwesomeIcon icon={faCaretDown}/>}</td>
              <td colSpan={1}><label>{themeObject.priority} - {themeObject.theme} ({themeObject.materials?.length})</label></td>
              <td>
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={(e) => {
                    confirmAlert({
                      title: `Use lesson theme ${themeObject.theme}`,
                      message: "For which classes do you want to use this theme?",
                      buttons: [
                        {
                          label: "Just this class",
                          onClick: () => markThemeUsed(themeObject.theme, false, false)
                        },
                        {
                          label: "All my classes today",
                          onClick: () => markThemeUsed(themeObject.theme, true, false)
                        },
                        {
                          label: "All my classes today in this School",
                          onClick: () => markThemeUsed(themeObject.theme, false, true)
                        },
                        {
                          label: "Cancel",
                        }
                      ]
                    });
                  }}
                >
                  <span>
                    <div style={{fontSize: 22}}>
                      <i className="fas fa-check-circle action"></i>
                    </div>
                    <div style={{fontSize: 10}}>
                      Use Theme
                    </div>
                  </span>
                </button>
                
              </td>
              <td>{colorAndTag.tag}</td>
              <td>{renderThemeInfoButton(themeObject)}</td>
            </tr>
        );

        const themeInfoRow = themeObject.currentDate && themeObject.ideas ? (
          <tr style={{backgroundColor: 'lightgray'}}>
            <td colSpan={4}><div style={{overflowY: 'scroll', maxHeight: 200}}><pre>{`${themeObject.ideas}`}</pre></div></td>
          </tr>
        ) : null;

        return [themeHeaderRow, ...materialForThemeRows, themeInfoRow, (<tr>&nbsp;</tr>)];
      });

      return materialRows;
    } else {
      return <div>No Materials available</div>
    }
  }

  const renderBody = () => {
    return(
      <>
      {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
            <div style={{ textAlign: 'center' }}>
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p style={{ marginTop: '10px' }}>Loading lesson data...</p>
            </div>
          </div>
        ) : (
        <>
        <div className="row">
          <div className="col-sm">
            <h2>{currentClass.title}</h2>
            {currentClass.location}
          </div>
          <div className="col-sm">
          </div>
          <div className="col-sm">
            <h2>{currentClass.teacher}</h2>
          </div>
        </div>
        <div className="row">
          
          <div className="form-group">
            <label htmlFor="notes">Class Notes</label>
            { currentClass.notes 
              ? (<textarea
              style={{maxHeight: 500, height: 200, color: 'black'}}
              type="text"
              className="form-control"
              readOnly={true}
              value={currentClass.notes}
            />): <div style={{color: 'gray', height: 30, borderColor: 'black', borderWidth: 1}}>No notes</div>
            }
          </div>
        </div>
        
        <div style={{margin: 5}}/>

        <div className="row">
          <Tabs>
            <TabList>
              <Tab>Attendance</Tab>
              <Tab>Materials</Tab>
            </TabList>

            <TabPanel>
            <div className="col">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <td></td>
                  {
                    [dateHeader].map(h => {
                      const attendanceHeaderStyle = h.editable ? (h.editing ? 'attendanceHeaderEditingOn' : 'attendanceHeaderEditingOff') : ''
                      const onHeaderClick = h.editable ? () => {
                        toggleEditRegister(h);
                      } : null;
                      return (
                        <td className={attendanceHeaderStyle} onClick={onHeaderClick}>
                          <div>{h.title}</div>
                        </td>)
                    })
                  }
                  </tr>
                </thead>
                <tbody>
                  { attendanceGrid && students.map(student => renderStudentAttendance(student))}
                </tbody>
              </table>
            </div>
            </TabPanel>
            <TabPanel>
              <div className="col">
                <div style={{margin: 10}}>
                  <div className="form-group">
                    <label htmlFor="notes">Lesson Notes</label>
                    <textarea
                      style={{height: 100}}
                      type="text"
                      className="form-control"
                      id="notes"
                      name="notes"
                      value={lesson.notes || ''}
                      onChange={event => setLesson({ ...lesson, notes: event.target.value })}
                    />
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={saveLesson}
                    >Save Lesson Notes</button>
                  </div>
                </div>
                <div style={{margin: 5}}/>
                <div>
                  <h4>Themes &amp; Materials</h4>
                  <table>
                  {renderMaterials(true)}
                  </table>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>
        </>
        )}
      </>
    )}

  return (
    <Container className="py-2 py-lg-4">
      <Row className="justify-content-center">
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Header className="d-flex align-items-center gap-2">
              <h2 className="mb-0">Class Register</h2>
            </Card.Header>
            <Card.Body className="p-3" style={{ overflowX: 'auto' }}>
              { renderBody()}
            </Card.Body>
            <Card.Footer className="text-muted">
              
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Lesson;